<template>
  <div class="app-inner fixed fixed-head-3">
    <!--/-->
    <div class="app-head">
      <common-header></common-header>
      <common-nav></common-nav>
      <el-row class="c_nav_menu_wrapper c_subnav">
        <el-menu :default-active="$route.path" class="c_nav_menu" mode="horizontal" router>
          <el-menu-item index="/report/daily">经营日报</el-menu-item>
          <el-menu-item index="/report/weekly">经营周报</el-menu-item>
          <el-menu-item index="/report/monthly">经营月报</el-menu-item>
          <el-menu-item index="/report/goods-divine">气温影响</el-menu-item>
          <!--<el-menu-item index="/report/weather-divine">预测2</el-menu-item>-->
          <!--<el-menu-item index="/report/finance-divine">预测3</el-menu-item>-->
          <!--<el-menu-item index="/report/effectscatter-divine">预测4</el-menu-item>-->
          <!--<el-menu-item index="/report/trend-divine">预测5</el-menu-item>-->
          <!--<el-menu-item index="/report/marker-divine">预测6</el-menu-item>-->
        </el-menu>
      </el-row>
    </div>

    <!--/-->
    <div class="app-body">
      <my-bscroll>
        <keep-alive>
            <router-view></router-view>
        </keep-alive>
      </my-bscroll>
    </div>
  </div>
</template>

<script>
  export default {
    data :function() {
      return {

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/report/_layout.vue